import React, { useRef, useState, useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import { Button } from "primereact/button";
import { renderTooltip } from "./helpful";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { downloadFile } from "./utilities";
import { addCart } from "../store/reducer";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import L_update_1 from "../assets/img/temp/L'Update_September2019/L'Update_September2019-1.jpg";
import L_update_2 from "../assets/img/temp/L'Update_September2019/L'Update_September2019-2.jpg";
import L_update_3 from "../assets/img/temp/L'Update_September2019/L'Update_September2019-3.jpg";
import L_update_4 from "../assets/img/temp/L'Update_September2019/L'Update_September2019-4.jpg";
import L_update_5 from "../assets/img/temp/L'Update_September2019/L'Update_September2019-5.jpg";
const PageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref} data-density="hard">
      <div className="page-content">
        <h2>{props.children}</h2>
      </div>
    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="page-content g-0">
        {/* <h2 className="page-header">Page header - {props.number}</h2> */}
        {/* <div className="page-image "></div> */}
        <div className="page-text">{props.children}</div>
        {/* <div className="page-footer">{props.number + 1}</div> */}
      </div>
    </div>
  );
});

const BookViewer = () => {
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const flipBook = useRef(null);

 
  const nextButtonClick = () => {
    if (flipBook.current) {
      flipBook.current.pageFlip().flipNext();
    }
  };

  const prevButtonClick = () => {
    if (flipBook.current) {
      flipBook.current.pageFlip().flipPrev();
    }
  };

  const onPage = (e) => {
    setPage(e.data);
  };

  useEffect(() => {
    if (flipBook.current) {
      setTimeout(() => {
        setTotalPage(flipBook.current.pageFlip().getPageCount());
      }, 0);
    }
  }, [flipBook]);

  const downloadItem = (e, item) => {
    e.preventDefault();
    downloadFile();
  };

  const addItem = (e, item) => {
    e.preventDefault();
    dispatch(addCart(item));
  };
  const handleBack = () => {
    navigate('/l-update');
  };

  return (
    <div className="">
      <HTMLFlipBook
        width={450}
        height={633}
        size="stretch"
        minWidth={315}
        maxWidth={1000}
        minHeight={400}
        maxHeight={1533}
        maxShadowOpacity={0.5}
        showCover={true}
        mobileScrollSupport={true}
        onFlip={onPage}
        className="book-flipper g-0"
        ref={flipBook}
      >
        <PageCover>
          {" "}
          <img src={L_update_1} alt="" className="lupdate-img" />
        </PageCover>

        <Page number={1}>
          <img src={L_update_2} alt="" className="lupdate-img" />
        </Page>
        <Page number={2}>
          <img src={L_update_3} alt="" className="lupdate-img" />
        </Page>
        <Page number={3}>
          <img src={L_update_4} alt="" className="lupdate-img" />
        </Page>
        <Page number={4}>
          <img src={L_update_5} alt="" className="lupdate-img" />
        </Page>

        <PageCover>
          <img src={L_update_5} alt="" className="lupdate-img" />
        </PageCover>
      </HTMLFlipBook>

      <div className="container lupdate-control-btn d-flex justify-content-between mb-4">
        <div className="  ">
          {/* <Button
            icon="pi pi-arrow-left"
            label="Back"
            severity="secondary"
            text
            className="text-white fs-6"
            onClick={handleBack}
          /> */}
           <a href="/"
            type="button"
            onClick={handleBack}
            className=" btn-xs bcb-btn-primary mt-2"
          >
            <i className="pi pi-arrow-left"></i> Back
          </a>
        </div>
        <div>
          <a href="/"
            type="button"
            onClick={prevButtonClick}
            className=" btn-xs bcb-btn-ternary mt-2"
          >
            <i className="bi bi-chevron-double-left"></i>
          </a>
          <span className="m-2">
            [<span>{page}</span> of <span>{totalPage}</span>]
          </span>
          <a href="/"
            type="button"
            onClick={nextButtonClick}
            className=" btn-xs bcb-btn-ternary mt-2"
          >
            <i className="bi bi-chevron-double-right"></i>
          </a>
        </div>
        
        <div className="mt-1  lupdate-control-btn-opt">
          <OverlayTrigger
            key={"add-to-cart"}
            placement="top"
            delay={{ show: 50, hide: 50 }}
            overlay={renderTooltip("Add to Cart")}
          >
            <a
              href="/"
              // onClick={(e) => {
              //   addItem(e, item);
              // }}
              className="col-md-4 col-sm-12 text-start px-3  text-center"
            >
              <i className="col bi bi-cart"></i>
            </a>
          </OverlayTrigger>
          <OverlayTrigger
            key={"Download"}
            placement="top"
            delay={{ show: 50, hide: 50 }}
            overlay={renderTooltip("Download")}
          >
            <a
              href="/"
              // onClick={(e) => downloadItem(e, item)}
              className="col-md-4 col-sm-12   text-start px-3  text-center"
            >
              <i className="col bi bi-download"></i>
            </a>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  );
};

export default BookViewer;
